$(document).on 'turbo:load', ->
  tooltip = document.querySelector('a[rel~=popover], .has-popover')
  createPopper tooltip, placement: 'top'
#$(document).on 'turbolinks:load', ->
#  $("a[rel~=popover], .has-popover").popover()
#  $("a[rel~=tooltip], .has-tooltip").tooltip()
